import { ReactNode } from 'react';

interface AuthSubmitButtonProps {
  children: ReactNode;
  loading?: boolean;
  loadingLabel?: string;
  type?: 'submit' | 'button';
  onClick?: () => void;
}

/**
 * The single primary action on each screen.
 *
 * While it is working the label itself changes, so the accessible name says
 * what is happening — a spinner alone would leave a screen reader with a
 * button that still claims to be "Sign in".
 */
export const AuthSubmitButton = ({
  children,
  loading = false,
  loadingLabel,
  type = 'submit',
  onClick,
}: AuthSubmitButtonProps) => (
  <button
    type={type}
    onClick={onClick}
    disabled={loading}
    className="w-full rounded-lg bg-auth-action px-4 py-3 text-[13px] font-semibold leading-4 text-auth-action-foreground transition-opacity hover:opacity-90 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-auth-accent focus-visible:ring-offset-2 focus-visible:ring-offset-auth-card disabled:cursor-not-allowed disabled:opacity-70"
  >
    {loading && loadingLabel ? loadingLabel : children}
  </button>
);
